var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('Statistics',{on:{"show":_vm.show}}),(_vm.activeBlock == 0)?_c('Categories'):_vm._e(),(_vm.activeBlock == 1)?_c('Products'):_vm._e(),(_vm.activeBlock == 2)?_c('Fields'):_vm._e(),(_vm.activeBlock == 3)?_c('FieldValue'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }